const onEmptyCart = () => {
  const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
  cartItems.updateQuantity(1, 0);
  // Re-enable the Free Gift when the cart is empty.
  setCookieFreeGiftTheme("");
}
document.addEventListener("EmptyCartEvent", onEmptyCart);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      let elementFreeItem = document.getElementsByClassName("cart-item-free");
      let isFreeItemRemove = elementFreeItem.item(0) !== null ? elementFreeItem.item(0).contains(this) : false;

      if (this.classList.contains("gift-remove")) {        
        let index = this.dataset.index;
        const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
        cartItems.updateQuantity(index, 0);
      } else {
        let modalToShow = (isFreeItemRemove) ? "Cart-Remove-Dialog-FreeProduct" : "Cart-Remove-Dialog";
        document.getElementById(modalToShow).setAttribute("open", "");       

        const onClickHandler = () => {
          document.getElementById(modalToShow).removeAttribute("open");
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          cartItems.updateQuantity(this.dataset.index, 0);
          document.querySelector("#"+modalToShow+" button[name='accept']").removeEventListener("click", onClickHandler);

          if (cartItems.getElementsByClassName("cart-item").length === 1) {
            // Re-enable the Free Gift when the cart is empty.
            setCookieFreeGiftTheme("");
          }
        };

        document.querySelector("#"+modalToShow+" button[name='accept']").addEventListener("click", onClickHandler);
      }
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.cartForm = document.getElementById("cart") || document.getElementById("CartDrawer-Form");
    if (this.cartForm) {
      if (this.cartForm == document.getElementById("cart")) this.validateMax();
      this.cartForm.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  
  async onSubmitHandler(evt) {
    evt.preventDefault();
    let target = evt.target;
    let thisObject = this;
    let cookieFreeGift = getCookie("bobochoses_freegift");
    if(cookieFreeGift !== false && cookieFreeGift !== "") {
      preSubmitCartValidation( function () {
        thisObject.onCartUpdate(true, target);
      });
    } else {
      thisObject.onCartUpdate(true, target);
    }
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate(false);
    });
  }
  
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    if (document.querySelector(".cart-items-free") && !document.querySelector(".cart-item-free") && this.freeGiftIsAdded()===false ) {
      this.getFreeGift()
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  validateMax() {
    const cartItems = document.querySelectorAll(".cart-item");
    if (cartItems) {
      cartItems.forEach((item) => {
        const input = item.querySelector(".quantity__input");
        if (input) {
          const maxQty = input.getAttribute("max");
          const valueQty = parseInt(input.value);
          if (maxQty && valueQty > parseInt(maxQty)) { 
            const maxMessage = window.cartStrings.quantityError.replace('[quantity]', maxQty);
            item.querySelector(".cart-item__error-text").textContent = maxMessage;
          }
        }
      });
    }
  }
  
  onCartUpdate(isSubmit, target) {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          if (isSubmit == true) {
            this.validateQtysAndSubmit(target);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          if (isSubmit == true) {
            this.validateQtysAndSubmit(target);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  validateQtysAndSubmit(target) {
    const cartItems = document.querySelectorAll(".cart-item");
    let cancelCheckout = false;
    cartItems.forEach((item) => {
      const input = item.querySelector(".quantity__input");
      if (input) {
        const maxQty = input.getAttribute("max");
        const valueQty = parseInt(input.value);
        if (maxQty && valueQty > parseInt(maxQty)) { 
          const maxMessage = window.cartStrings.quantityError.replace('[quantity]', maxQty);
          item.querySelector(".cart-item__error-text").textContent = maxMessage;
          cancelCheckout = true;
        }
      }
    });
    if (!cancelCheckout) {
      let newTarget = document.getElementById(target.id);
      const cartSubmitInput = document.createElement('input');
      cartSubmitInput.setAttribute('name', 'checkout');
      cartSubmitInput.setAttribute('type', 'hidden');
      newTarget.appendChild(cartSubmitInput);
      newTarget.submit();
    }
  }

  getFreeGift() {
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let addData = {
      'id': cart.dataset.free,
      'quantity': 1,
      'sections': cart.getSectionsToRender().map((section) => section.id),
      'sections_url': window.location.pathname
    }
    setCookieFreeGiftTheme(cart.dataset.free);
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then((response) => {
      cart.renderContents(response);    
    })
    .catch((e) => {
      console.error(e);
      setCookieFreeGiftTheme("");
    })
  }

  freeGiftIsAdded() {
    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let cookieFreeGift = getCookie("bobochoses_freegift");
    return (cookieFreeGift === cart.dataset.free);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    let maxAttribute;
    let currentElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    if (currentElement) maxAttribute = parseInt(currentElement.getAttribute("max"));
    if (maxAttribute && parseInt(currentElement.value) > maxAttribute) {
      currentElement.value = maxAttribute;
      let maxMessage = window.cartStrings.quantityError.replace('[quantity]', maxAttribute);
      this.updateLiveRegions(line, maxMessage);
      this.disableLoading(line);
      return;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace == undefined) return;
          if( section.id === 'CartDrawer') {
            this.removeCartModalsFromDOM();
          }
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});

        var giftExists = document.querySelector(".cart-item-gift");
        var freeExists = document.querySelector(".cart-item-free");
        var cartItems = document.querySelector("cart-drawer-items") || document.querySelector("cart-items")
        var freeItems = document.querySelector("cart-drawer-items") || document.querySelector("table.cart-items");
        if((giftExists && !freeExists && parsedState.items.length == 1) || (!giftExists && freeExists && parsedState.items.length == 1) || (giftExists && freeExists && parsedState.items.length == 2))
        {
          document.dispatchEvent(new Event("EmptyCartEvent"));          
        } else if (freeExists && freeItems && freeItems.classList.contains("unselected-collection")) {
          cartItems.updateQuantity(freeExists.dataset.index, 0);
        }
        this.validateMax();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  removeCartModalsFromDOM() {
    if(document.querySelectorAll('#PopupModal-Note-cart').length > 0) {
      document.getElementById('PopupModal-Note-cart').remove();
    }
    if(document.querySelectorAll('#PopupModal-Gift-cart').length > 0) {
      document.getElementById('PopupModal-Gift-cart').remove();
    }
    if(document.querySelectorAll('#Cart-Remove-Dialog').length > 0) {
      document.getElementById('Cart-Remove-Dialog').remove();
    }
    if(document.querySelectorAll('#Cart-Remove-Dialog-FreeProduct').length > 0) {
      document.getElementById('Cart-Remove-Dialog-FreeProduct').remove();
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      let error = this.querySelector(".cart-note-error");

      this.addEventListener('input', debounce(async (event) => {
        var latinRegex = /^[A-Za-z\s]+$/;
        if (event.target.value.length > 0 && !latinRegex.test(event.target.value)) {
          if (!error.classList.contains("hidden")) error.classList.add("hidden");
          // Remove non-Latin characters from input
          event.target.value = event.target.value.replace(/[^A-Za-z\s]+/g, '');
          // Optional: Display a message to the user
          if (error.classList.contains("hidden")) error.classList.remove("hidden");
          return;
        }
        await this.saveValue(event.target.value);
      }, ON_CHANGE_DEBOUNCE_TIMER))

      const summary = this.parentNode.querySelector("summary");

      summary.addEventListener('click', async () => {
        await this.saveValue('');
      });

      this.saveValue = debounce(async (value) => {
        await this.saveValueAsync(value);
      }, ON_CHANGE_DEBOUNCE_TIMER)
    }

    async saveValueAsync(value) {
      const body = JSON.stringify({ note: value });
      await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }

    async saveCurrentValue() {
      await this.saveValue(this.querySelector('textarea').value);
    }
  });
};

function miniCartValidation() {
  let cookieFreeGift = getCookie("bobochoses_freegift");
  if(cookieFreeGift !== false && cookieFreeGift !== "") {    
    getCartAndProcess( function ( data ){
      resetFreeGiftQuantity(data);
      window.location.href = routes.cart_url;
    }, function (){
      window.location.href = routes.cart_url;
    });    
  } else {
    window.location.href = routes.cart_url;
  } 
}

async function preSubmitCartValidation( callback ) {
  getCartAndProcess( function ( data ){
    resetFreeGiftQuantity(data);
    callback();
  }, function () {
    callback();
  });
}

function resetFreeGiftQuantity(data) {
  let cookieFreeGift = getCookie("bobochoses_freegift");
  let giftCounter = 0;
  data.items.forEach((item) => {
    giftCounter = (item.id == cookieFreeGift) ? item.quantity : giftCounter;
  });

  if(giftCounter > 1) {
    let lineFreeItem = document.querySelector("tr[data-id='"+cookieFreeGift+"']");
    let index = lineFreeItem.getAttribute('data-index');

    const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
    cartItems.updateQuantity(index, 1);          
  }
}

async function getCartAndProcess(callbackSuccess, callbackError) {
  await fetch(`${routes.cart_url}.js`,
  {
    method: "GET",
    headers: { 'Content-Type': 'application/json',},
    body: null
  })
  .then(
    (response) => 
      response.json()
    )
  .then(data => {
    if((typeof callbackSuccess) === 'function') {
      callbackSuccess(data);
    }
  })
  .catch((error) => {
    console.log('Error:', error.message);    
    if((typeof callbackError) === 'function') {
      callbackError();
    }
  });
}